export const getReservations = async (welletContext, body) => {
  try {
    const result = await welletContext.apis.tickets.post(`/reservation/all`, body);
    return result.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const fetchCities = async (welletContext) => {
  try {
    const result = await welletContext.apis.tickets.get('/shows/cities');
    return result.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const putReservation = async (
  showId,
  paxs,
  customer,
  comments,
  occasion,
  countryCode,
  reservationDateTime,
  totalAmount,
  products,
  lang,
  eventId,
  reservationType,
  description,
  expirationOffset,
  notificationMethod,
  externalRefCode,
  welletContext,
  currency,
  customFields,
  transfers = null,
) => {
  try {
    const body = {
      showId,
      paxs,
      customer,
      customerLanguage: lang,
      comments: comments,
      occasion: occasion,
      countryCode: countryCode,
      reservationDateLocalTime: reservationDateTime,
      totalAmount: totalAmount,
      products: products,
      eventId,
      reservationType,
      expirationOffset,
      notificationMethod,
      externalReferenceCode: externalRefCode,
      description,
      language: null, //It shouldn't be sent, but the API sets it to "ES".
      customerCurrency: currency,
      customFields
    };
    if (transfers) {
      body.reservationTransferRequest = transfers;
    }

    const result = await welletContext.apis.tickets.put('/reservation/generatereservation', body);
    return result.data;
  } catch (error) {
    console.error(error);
    if (error.response && error.response.data) {
      throw new Error('reservationError.' + error.response.data.errorType);
    } else {
      throw new Error('apiError');
    }
  }
};


export const payReservation = async (
  token,
  card,
  customer,
  amount,
  installments,
  notificationMethod,
  welletContext,
  processingMode,
  deviceId,
) => {
  try {
    const body = {
      token,
      card,
      customer,
      amount,
      installments,
      notificationMethod,
      processingMode,
      deviceId,
    };

    const response = await welletContext.apis.tickets.post(`/reservation/payDeposit`, body);

    return response.data;
  } catch (error) {
    console.error(error);

    if (error.response && error.response.data) {
      throw new Error('paymentError.' + error.response.data.errorType);
    } else {
      throw new Error('apiError');
    }
  }
};

export const getReservation = async (reservationId, welletContext) => {
  try {
    const result = await welletContext.apis.tickets.get(`/reservation/${reservationId}`);
    return result.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const fetchPickups = async (eventShowId , reservationType, welletContext) => {
  try {
    const response = await welletContext.apis.tickets.get(`/pickup/get`, {
      params: { eventShowId , reservationType },
    });

    return response.data;
  } catch (error) {
    console.error(error);

    if (error.response && error.response.data) {
      throw new Error('paymentError.' + error.response.data.errorType);
    } else {
      throw new Error('apiError');
    }
  }
};

export const fetchPickupDetails = async (eventShowId , reservationType, name, date, welletContext,pickupAdressId ) => {
  try {
    const body = {
      eventShowId ,
      reservationType,
      name,
      date,
      pickupAdressId 
    };

    const response = await welletContext.apis.tickets.post(`/pickup/details`, body);

    return response.data;
  } catch (error) {
    console.error(error);

    if (error.response && error.response.data) {
      throw new Error('paymentError.' + error.response.data.errorType);
    } else {
      throw new Error('apiError');
    }
  }
};
